// Auto-generated from variables.scss
export const colors = {
  "primary-color": "#0074B8",
  "secondary-color": "#acc32b",
  "success-color": "#2e7d32",
  "error-color": "#d32f2f",
  "error-hover": "#EF5350",
  "error-dark": "#B71C1C",
  "critical-color": "#E81144",
  "critical-hover": "#E81144",
  "critical-dark": "#c00e3a",
  "warning-color": "#ed6c02",
  "info-color": "#0288d1",
  "primary-light": "#3399cc",
  "primary-dark": "#005a8f",
  "primary-pressed": "#0065A2",
  "primary-hover": "#2F93C6",
  "primary-contrastText": "#FFFFFF",
  "primary-outlined-active-bg": "#CDE7F7",
  "primary-outlined-hover-bg": "#def7ff",
  "secondary-light": "#C4D85A",
  "secondary-dark": "#8FA023",
  "secondary-hover": "#B8CC3D",
  "secondary-contrastText": "#FFFFFF",
  "neutral-color": "#616161",
  "neutral-outlined-hover-bg": "#F5F5F5",
  "neutral-border": "#c3c7cf",
  "neutral-border-hover": "#333e48",
  "operator-dashboard-card-border": "#edf1f7",
  "operator-dashboard-overview-ring-complete-fill": "#f4f6f9",
  "operator-dashboard-overview-ring-complete-border": "#dde2ea",
  "elevated-border": "#24ceff",
  "elevated-hover-bg": "#def7ff",
  "elevated-active-overlay": "rgba(0, 0, 0, 0.04)",
  "elevated-text": "#0065a2",
  "pivot-text-default": "#232e38",
  "pivot-text-active": "#0065a2",
  "pivot-text-hover": "#0065a2",
  "pivot-indicator-color": "#0074b8",
  "tertiary": "#0099c2",
  "tertiary-light": "#33B3D9",
  "tertiary-dark": "#007A9A",
  "tertiary-contrastText": "#FFFFFF",
  "text-primary": "#000000de",
  "text-secondary": "#00000099",
  "text-disabled": "#00000061",
  "text-white": "#FFFFFF",
  "bg-primary": "#FFFFFF",
  "bg-secondary": "#F1F7FB",
  "bg-disabled": "#e0e0e0",
  "radio-color-default": "#9e9e9e",
  "radio-color-hover": "#616161",
  "pill-text-matte": "#232e38",
  "pill-clear-icon-bg": "rgba(51, 62, 72, 0.1)",
  "pill-breeze-fill": "#f2fbfa",
  "pill-breeze-stroke": "#40c9ba",
  "pill-agenta-fill": "#fef3f6",
  "pill-agenta-stroke": "#f388a1",
  "pill-secure-fill": "#fffcf0",
  "pill-secure-stroke": "#ffdf79",
  "pill-blue-fill": "#f2f8fb",
  "pill-blue-stroke": "#4097ca",
  "input-border-default": "#c3c7cf",
  "input-border-hover": "#333e48",
  "input-fill-disabled": "#f7f8f9",
  "input-placeholder-text": "#afb5bf",
  "input-helper-text": "#656d74",
  "chip-email-recipient-chip-bg": "#f2f8fb",
  "chip-email-recipient-chip-border": "#7eb8dc",
  "search-filter-icon-color": "#232e38",
  "dropdown-item-hover-bg": "#def7ff",
  "dropdown-main-text": "#232e38",
  "timeline-frost": "#e4edf8",
  "timeline-matte": "#232e38",
  "timeline-fog": "#afb5bf",
  "timeline-marker-border": "#d0d5db",
  "timeline-marker-inner": "#9ca3af",
  "scheduling-readonly-field-label": "#9ca3af",
  "notification-info-border": "#e4edf8",
  "notification-warning-border": "#ffd54c",
  "notification-error-border": "#e81144",
  "notification-success-border": "#00b7a3",
  "tooltip-text-color": "#232e38",
  "calendar-bg": "#ffffff",
  "calendar-date-item-fill": "#def7ff",
  "calendar-date-item-stroke": "#0074b8",
  "calendar-date-item-text": "#232e38",
  "carrier-compliance-meta-text": "#4f5860",
  "carrier-compliance-field-label": "#70777e",
  "app-shell-sidebar-frost": "#e4edf8",
  "app-shell-sidebar-carbon": "#131e29",
  "app-shell-sidebar-grit": "#000005",
  "app-shell-sidebar-selected-text-light": "#0065a2",
  "app-shell-sidebar-hover-rail-dark": "rgb(47 147 198 / 16%)",
  "app-shell-sidebar-hover-rail-light": "rgb(47 147 198 / 10%)",
  "settings-invite-pill-bg": "rgba(255, 255, 255, 0.95)",
  "settings-invite-pill-border": "#c3c8cf",
  "user-form-drawer-title-color": "#242836",
};
